import { render, staticRenderFns } from "./CTab.vue?vue&type=template&id=140ae252&"
import script from "./CTab.vue?vue&type=script&lang=ts&"
export * from "./CTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports